import { SwitchField } from 'forms';
import t from 'rcm-i18n';
import React from 'react';

import './style.scss';

interface Props {
    allowAnalytics;
    onValueChange;
}

const CookieNoticeSettings = ({
    allowAnalytics,
    onValueChange,
}: Props) =>
    <table className="cookie-notice-settings table">
        <tr>
            <th>{t('Strictly Necessary Cookies')}</th>
            <td><em>{t('Always Active')}</em></td>
        </tr>
        <tr>
            <th>{t('Third-party cookies')}</th>
            <td>
                <SwitchField
                    name="allowAnalytics"
                    value={allowAnalytics}
                    onValueChange={onValueChange}
                    valueLabelOn={t('Cookies Active')}
                    valueLabelOff={t('Cookies Inactive')}
                />
            </td>
        </tr>
    </table>
;

export default CookieNoticeSettings;
